import { useMutation } from 'react-query';

import { exportCsvReport as mutationFn } from 'api/endPoints/exportCsvReport';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export interface ITrackUnTrackPayload {
    taskVersionHashCode: string;
    toTrack: boolean;
    contractId?: number | null;
}

export interface IExportCsvReportPayload {
    compareVersionId?: number;
    contractId?: number | null;
    filter: { filters: IFilter[] | undefined };
    latestVersionId?: number | null;
    period: string;
    projectId?: number | null;
    reportType: string;
    fileName: string;
}

export const useMutationExportCsvReport = () => {
    return useMutation<unknown, QueryError, IExportCsvReportPayload>((params) => mutationFn(params));
};
